// extracted by mini-css-extract-plugin
module.exports = {"container":"PageDefault_container__omjwn","main":"PageDefault_main__aX8mX"};